<template>
    <div class="pb-2 space-y-8">
        <!-- Attendees -->
        <div>
            <MeetingDetailsSectionTitle iconName="users">
                Attendees
            </MeetingDetailsSectionTitle>
            <div class="space-y-2 mt-2">
                <div
                    v-for="reservationData in meetingData.reservationsData"
                    :key="reservationData.reservation.id.value"
                >
                    <ReservationCard
                        :meeting="meetingData.meeting"
                        :isSingleReservation="
                            meetingData.hasSingleReservation()
                        "
                        :reservationData="reservationData"
                        :attendanceData="
                            meetingData.getAttendanceDataByReservation(
                                reservationData.reservation.id,
                            )
                        "
                        :companyUser="companyUser"
                        @onRefundReservationSuccess="
                            emits('onRefundReservationSuccess', {
                                meetingData: $event.meetingData,
                            })
                        "
                        @onToggleNoShowAttendanceSuccess="
                            emits('onToggleNoShowAttendanceSuccess', {
                                meetingData: $event.meetingData,
                            })
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import MeetingDetailsSectionTitle from '@/App/Booking/Meeting/Component/MeetingDetailsSectionTitle.vue'
    import ReservationCard from '@/App/Booking/Meeting/Component/ReservationCard.vue'

    const emits = defineEmits<{
        onRefundReservationSuccess: [{ meetingData: MeetingData }]
        onToggleNoShowAttendanceSuccess: [{ meetingData: MeetingData }]
    }>()

    const props = defineProps({
        meetingData: {
            type: Object as PropType<MeetingData>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
    })
</script>
